// extracted by mini-css-extract-plugin
module.exports = {"Container":"LIAiG","Message":"_3U6mn","Image":"L-C2J"};